import MyHeader from '../../Home/MyHeader';
import {ConfigProvider} from 'antd';
import MyFooter from '../../Home/MyFooter';
import img1 from '../../resource/eagle-chip-1.png';
import '../NewsStyles.css';

export default function Index() {
  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            horizontalItemSelectedBg: '#ffffff',
            horizontalItemSelectedColor: '#203864',
            itemColor: '#203864',
            itemPaddingInline: 24,
            activeBarHeight: 0,
          },
          Collapse: {
            contentPadding: 0
          }
        },
      }}
    >
      <MyHeader/>
      <main className="news-room-body">
        <div className="new-room-content">
          <h1>异格技术首款量产芯片P1成功点亮！</h1>
          <p className="news-room-date">2025年9月25日</p>
          <img src={img1} alt="Eagle Chip"/>
          <br/>
          <p>
            2025年9月25日，苏州异格技术迎来又一重要里程碑——首款量产FPGA芯片P1实现一次性成功点亮。这标志着异格技术FPGA芯片已成功跨越从设计到量产的关键门槛，步伐坚定的迈向新阶段。
          </p>
          <p>
            作为异格首款量产FPGA芯片，P1延续了“高性能、低功耗、差异化”的产品理念，严格遵循高可靠性标准，从架构优化、核心模块性能和高速接口等方面全面实现了提升，为异格客户在高性能可编程器件应用领域提供了全新选择。
          </p>
          <p>
            未来，异格技术将持续探索P1芯片与应用场景的深度融合，并不断拓展产品边界，发挥国产高端FPGA芯片的真正价值，合力构建全球智能化数字化新生态。
          </p>
        </div>
      </main>
      <MyFooter/>
    </ConfigProvider>
  );
}